import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from './ClassName.protypes';
import { DisabledDefaultProps, DisabledPropTypes } from './Disabled.proptypes';
import {
  IsLoadingDefaultProps,
  IsLoadingPropTypes,
} from './IsLoading.proptypes';

export const BaseDefaultProps = {
  ...ClassNameDefaultProps,
  ...DisabledDefaultProps,
  ...IsLoadingDefaultProps,
};

export const BasePropTypes = {
  ...ClassNamePropTypes,
  ...DisabledPropTypes,
  ...IsLoadingPropTypes,
};
